<div class="row h-100 p-3 text-dark">
  <t-llevo-detail-tab-item
    class="col-6"
    contentClasses="h-100 w-100 text-dark d-block"
    rowClasses="py-1"
    [data]="tabItems"
  ></t-llevo-detail-tab-item>
  @if(imageUrl){
  <commonui-preload-img
    class="col-6 h-50"
    [urlImg]="imageUrl"
    imgClass="w-100 h-100"
    [containerHeight]="100"
    [containerWidth]="100"
    unit="%"
  >
  </commonui-preload-img>
  }
</div>
